export const mainChannels = [
  {
    value: "web",
    title: "Web",
    icon: "newspaper-variant-outline"
  },
  {
    value: "print",
    title: "Print",
    icon: "library"
  },
  {
    value: "print2",
    title: "Print Eberl Medien",
    icon: "cloud-print-outline"
  },
  {
    value: "app",
    title: "App",
    icon: "cellphone"
  }
];
